import { ProviderManagementComponent } from './admin/provider-management/provider-management.component';
import { AdminComponent } from './admin/admin.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AngularFireAuthGuard,
  redirectUnauthorizedTo,
  redirectLoggedInTo,
} from '@angular/fire/compat/auth-guard';
import { PracticeFormComponent } from './admin/practice-form/practice-form.component';
import { NotifyButtonComponent } from './shared/components/notify-button/notify-button.component';
import { LiveOperationsComponent } from './live-operations/live-operations.component';
import { OrtMastersComponent } from './ort-masters/ort-masters.component';
const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['/login']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['/dashboard']);

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
  },
  {
    path: '',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'admin',
    component: AdminComponent,
  },
  {
    path: 'admin/practice/providers',
    component: ProviderManagementComponent,
  },
  {
    path: 'admin/practice/update-form/change',
    component: PracticeFormComponent,
  },
  {
    path: 'message/notify-button',
    component: NotifyButtonComponent,
  },
  {
    path: 'live-operations',
    component: LiveOperationsComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'ort-masters',
    component: OrtMastersComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
